import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import { useState } from "react";
import { ClockIcon } from "../../../assets/imgs";
import { Location } from "iconsax-react";

const HotspotPositionMarker: React.FC<{ data: any }> = ({ data }) => {
  const [showInfoWindowByIndex, setShowInfoWindowByIndex] = useState(false);

  const [markerRef, marker] = useAdvancedMarkerRef();

  const position = {
    lat: data.coordinates[0],
    lng: data.coordinates[1]
  };
  
  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        onClick={() => setShowInfoWindowByIndex(true)}
      >
        <div
          className="w-fit" 
          onMouseOver={() => setShowInfoWindowByIndex(true)}
          onMouseOut={() => setShowInfoWindowByIndex(false)}
        >
          <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px]">
          <Location width={18} height={18} variant="Bulk" color={'#fff'}/>
          </div>
        </div>
      </AdvancedMarker>
      {showInfoWindowByIndex && (
        <InfoWindow
          pixelOffset={[0, 30]}
          anchor={marker}
          maxWidth={200}
          headerDisabled
        >
          <span className="font-semibold">Nome:</span> {data?.name}
          <br />
          <span className="font-semibold">Raio de alcance:</span> {data?.radius}m
        </InfoWindow>
      )}
    </>
  );
};

export default HotspotPositionMarker;
